import { nameof } from "@libs/utils/name-of.utils.ts";
import { Validator } from "@libs/validation/Validator.ts";
import { InjuryDiagnosisAndAssistanceFormValues } from "@shared-types/acc/injury-diagnosis-and-assistance-values.type.ts";

import { ClaimDiagnosisValidator } from "../../claim-adjustment/validators/ClaimDiagnosisValidator.tsx";

export class InjuryDiagnosisAndAssistanceDraftValidator extends Validator<InjuryDiagnosisAndAssistanceFormValues> {
  constructor() {
    super();

    const claimDiagnosisValidator = new ClaimDiagnosisValidator();

    this.forArrayField(
      nameof("claimDiagnosis"),
      claimDiagnosisValidator.validate
    );
  }
}
